import { Component, Input, OnDestroy } from "@angular/core";
import { IdService } from "../shared/services/id.service";


@Component({
	selector: "rbc-spinner",
	template: `
		<rbc-transition type="opacity" [state]="true" [forceState]="true">
			<div
				[id]="id"
				[attr.aria-label]="loadingLabel"
				[attr.aria-busy]="true"
				role="progressbar"
				class="rbc-spinner"
				[ngClass]="{ 'rbc-spinner-overlay': overlay, 'rbc-spinner-fixed': fullPage}"
			>
				<div
					class="rbc-spinner-wrap"
					[ngClass]="classGen()"
				>
					<svg
						[attr.aria-label]="loadingLabel"
						class="rbc-spinner-icon"
						viewBox="0 0 50 50"
					>
						<circle
							class="rbc-spinner-circle"
							cx="25"
							cy="25"
							r="24"
						></circle>
						<circle
							class="rbc-spinner-circle rbc-spinner-circle-loader"
							cx="25"
							cy="25"
							r="24"
						></circle>
					</svg>
				</div>
			</div>
		</rbc-transition>
	`,
	styles: []
})
export class SpinnerComponent implements OnDestroy {
	// Private Members
	@Input() id: string;

	// Input Parameters
	@Input() overlay = false;
	@Input() fullPage = false;
	@Input() loadingLabel = "Content is loading";
	@Input() size: "small" | "medium" | "large" = "medium";
	@Input() positionY: "top" | "middle" | "bottom";

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	classGen() {
		const classes = {};
		classes["rbc-spinner-" + this.size] = this.size;
		if (this.positionY) {
			classes["rbc-spinner-absolute"] = true;
			classes["rbc-spinner-" + this.positionY] = this.positionY;
		}

		return classes;
	}
}
